import { createFileRoute } from "@tanstack/react-router"

import { marketingPages } from "@/lib/marketing-pages"
import { seoMeta } from "@/lib/seo"

import { ProjectsPage } from "../../-components/projects/ProjectsPage"

export const Route = createFileRoute("/about/projects/")({
  head: () =>
    seoMeta({
      title: "Projects · Entire",
      description: marketingPages["/about/projects"].description,
      url: "https://entire.com/about/projects",
    }),
  component: ProjectsRoute,
})

function ProjectsRoute() {
  return <ProjectsPage />
}
